"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var April = require("april");
var Iris = require("iris");
var Carol = require("carol");
var lodash_1 = require("lodash");
var moment_1 = require("moment");
var getters = require("./getters");
function init(store) {
    return __awaiter(this, void 0, void 0, function () {
        var carolCampaign, _i, _a, special, campaignId, cruises_1, cruises, routes, airports, regions;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (store.state.searchResults.length > 0) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, Carol.client.campaignList(store.state.config.campaignId)];
                case 1:
                    carolCampaign = _b.sent();
                    if (!carolCampaign) return [3 /*break*/, 6];
                    if (!(carolCampaign.specialOffers && carolCampaign.specialOffers.length)) return [3 /*break*/, 5];
                    _i = 0, _a = carolCampaign.specialOffers;
                    _b.label = 2;
                case 2:
                    if (!(_i < _a.length)) return [3 /*break*/, 5];
                    special = _a[_i];
                    if (!special.campaignId)
                        return [2 /*return*/, true];
                    campaignId = special.campaignId;
                    return [4 /*yield*/, April.client.campaignCruisesById(special.campaignId)];
                case 3:
                    cruises_1 = _b.sent();
                    store.commit('SET_APRIL_CAMPAIGN', { campaignId: campaignId, cruises: cruises_1 });
                    _b.label = 4;
                case 4:
                    _i++;
                    return [3 /*break*/, 2];
                case 5:
                    store.commit('SET_CAROL_CAMPAIGN', carolCampaign);
                    _b.label = 6;
                case 6: return [4 /*yield*/, Iris.client.searchCruisesGrouped({
                        adults: lodash_1.toNumber(store.state.config.persons[0]),
                        juveniles: lodash_1.toNumber(store.state.config.persons[1]),
                        children: lodash_1.toNumber(store.state.config.persons[2]),
                    })
                    // console.log('cruises', cruises)
                    /* if (cruises.length === store.state.searchResults.length) {
                      return
                    } */
                    // create a copy so we dont write into the iris result
                ];
                case 7:
                    cruises = _b.sent();
                    routes = JSON.parse(JSON.stringify(cruises));
                    routes = lodash_1.map(routes, function (route) {
                        route.cruises = lodash_1.filter(route.cruises, function (cruise) {
                            // console.log('cruise', cruise.prices)
                            //fixed to two travellers
                            if (!cruise.prices[store.state.config.persons]) {
                                return false;
                            }
                            if (store.state.config.weeks) {
                                var dates = limitDates(store.state.config.weeks);
                                if (!moment_1.utc(cruise.start, 'DD.MM.YYYY').isBetween(dates.timeFrom, dates.timeTo, null, '[]')) {
                                    return false;
                                }
                            }
                            if (store.state.config.priceModel) {
                                var priceInfo = lodash_1.find(cruise.prices[store.state.config.persons], {
                                    priceModel: store.state.config.priceModel,
                                });
                                if (!priceInfo)
                                    return false;
                            }
                            return true;
                        });
                        route.cruises = lodash_1.map(route.cruises, function (cruise) {
                            if (store.state.config.priceModel) {
                                cruise.priceInfo = lodash_1.find(cruise.prices[store.state.config.persons], {
                                    priceModel: store.state.config.priceModel,
                                });
                            }
                            else {
                                cruise.priceInfo = lodash_1.minBy(cruise.prices[store.state.config.persons], 'amount');
                            }
                            if (!cruise.priceInfo) {
                                return;
                            }
                            cruise.priceModel = cruise.priceInfo.priceModel;
                            if (cruise.priceModel === 'IND') {
                                cruise.priceModel = 'PREMIUM';
                            }
                            cruise.earlyBird = lodash_1.find(cruise.priceInfo.surcharges, function (surcharge) {
                                return surcharge.type === 'EB' || surcharge.type === 'EBP';
                            });
                            cruise.price = cruise.priceInfo.amount;
                            var priceData = lodash_1.find(cruise.prices[store.state.config.persons], function (price) {
                                return price.priceModel === cruise.priceInfo.priceModel;
                            });
                            cruise.flight = priceData && priceData.flight ? priceData.flight : false;
                            return cruise;
                        });
                        route.cruises = lodash_1.compact(route.cruises);
                        if (route.cruises.length) {
                            var cruise = lodash_1.minBy(route.cruises, 'price');
                            route.cheapestCruiseIndex = lodash_1.findIndex(route.cruises, {
                                price: cruise.price,
                            });
                        }
                        return route;
                    });
                    routes = lodash_1.filter(routes, function (route) {
                        return route.cruises.length;
                    });
                    lodash_1.map(routes, function (route) {
                        route.cruises = lodash_1.map(route.cruises, function (cruise) {
                            cruise.datesDisplay = cruise.start + " bis " + cruise.end;
                            return cruise;
                        });
                        route.cruises = lodash_1.sortBy(route.cruises, function (cruise) {
                            return moment_1.utc(cruise.start, 'DD.MM.YYYY').unix();
                        });
                        if (route.startHabour === route.endHabour) {
                            route.description = route.duration + " Tage ab/bis " + route.startHabour;
                        }
                        else {
                            route.description = route.duration + " Tage von " + route.startHabour + " nach " + route.endHabour;
                        }
                    });
                    store.commit('SET_RESULTS', routes);
                    return [4 /*yield*/, Carol.client.airports({ keys: ['id', 'name'] })];
                case 8:
                    airports = _b.sent();
                    initAirportList(store, airports, routes);
                    return [4 /*yield*/, Carol.client.regions({ keys: ['id', 'name'] })];
                case 9:
                    regions = _b.sent();
                    initRegionList(store, regions, routes);
                    lodash_1.forEach(store.state.carolCampaign.specialOffers, function (special) {
                        lodash_1.forEach(special.routes, function (route) {
                            var specialRoutes = specialCruisesData(store, route, JSON.parse(JSON.stringify(cruises)));
                            var code = special.name;
                            store.commit('SET_SPECIAL_RESULTS', { routes: specialRoutes, code: code });
                        });
                    });
                    return [2 /*return*/];
            }
        });
    });
}
exports.init = init;
function updateCurrentPage(store, page) {
    store.commit('SET_CURRENT_PAGE', page);
}
exports.updateCurrentPage = updateCurrentPage;
function updateFilter(store, _a) {
    var key = _a.key, value = _a.value;
    store.commit('SET_FILTER', { key: key, value: value });
    if (store.state.paging.currentPage > getters.numberPages(store.state)) {
        updateCurrentPage(store, getters.numberPages(store.state));
    }
}
exports.updateFilter = updateFilter;
function updateSortBy(store, option) {
    store.commit('SET_SORTBY', option);
}
exports.updateSortBy = updateSortBy;
function updateSpecialSortBy(store, option) {
    store.commit('SET_SPECIAL_SORTBY', option);
}
exports.updateSpecialSortBy = updateSpecialSortBy;
function resetStore(store) {
    store.commit('RESET_STATE');
}
exports.resetStore = resetStore;
function initAirportList(store, airports, routes) {
    var availableAirportIds = [];
    lodash_1.forEach(routes, function (route) {
        availableAirportIds = lodash_1.concat(availableAirportIds, lodash_1.flatMap(route.cruises, function (cruise) {
            return cruise.airports;
        }));
    });
    availableAirportIds = lodash_1.uniq(availableAirportIds);
    var airportList = lodash_1.map(availableAirportIds, function (id) {
        var airport = lodash_1.find(airports, { id: id });
        return {
            id: id,
            name: airport ? airport.name : 'unbekannt ' + id,
            shortName: airport ? airport.name : 'unbekannt ' + id,
        };
    });
    setAirports(store, airportList);
}
exports.initAirportList = initAirportList;
function initRegionList(store, regions, routes) {
    var availableRegionIds = [];
    availableRegionIds = lodash_1.concat(availableRegionIds, lodash_1.flatMap(routes, function (route) {
        return route.regionIDs;
    }));
    availableRegionIds = lodash_1.uniq(availableRegionIds);
    var regionList = lodash_1.map(availableRegionIds, function (id) {
        var region = lodash_1.find(regions, { id: id });
        return {
            id: id,
            name: region ? region.name : 'unbekannt ' + id,
            shortName: region ? region.name : 'unbekannt ' + id,
        };
    });
    setRegions(store, regionList);
}
exports.initRegionList = initRegionList;
function setAirports(store, airports) {
    store.commit('SET_AIRPORTS', airports);
}
exports.setAirports = setAirports;
function setRegions(store, regions) {
    store.commit('SET_REGIONS', regions);
}
exports.setRegions = setRegions;
function setShips(store, ships) {
    var filterShips = lodash_1.map(ships, function (ship) {
        return {
            id: ship.id,
            name: ship.name,
            shortName: ship.name,
        };
    });
    store.commit('SET_SHIPS', filterShips);
}
exports.setShips = setShips;
function setCruises(store, cruises) {
    store.commit('SET_CRUISES', cruises);
}
exports.setCruises = setCruises;
// export everything compliant to the vuex specification for actions
exports.default = {
    init: init,
    setAirports: setAirports,
    setRegions: setRegions,
    setShips: setShips,
    updateCurrentPage: updateCurrentPage,
    updateSortBy: updateSortBy,
    updateSpecialSortBy: updateSpecialSortBy,
    updateFilter: updateFilter,
    resetStore: resetStore,
};
function limitDates(weeks) {
    return {
        timeFrom: moment_1.utc(new Date()).format('YYYY-MM-DD'),
        timeTo: moment_1.utc(new Date())
            .add(weeks, 'weeks')
            .format('YYYY-MM-DD'),
    };
}
function specialCruisesData(store, specialRoute, routes) {
    // console.log('config', JSON.stringify(config))
    routes = lodash_1.map(routes, function (route) {
        route.cruises = lodash_1.filter(route.cruises, function (cruise) {
            //fixed to two travellers
            if (!cruise.prices[store.state.config.persons]) {
                return false;
            }
            if (specialRoute.start &&
                specialRoute.end &&
                specialRoute.name === route.name &&
                moment_1.utc(cruise.start, 'DD.MM.YYYY').isBetween(moment_1.utc(specialRoute.start), moment_1.utc(specialRoute.end), null, '[]')) {
                return true;
            }
            if (lodash_1.find(specialRoute.cruises, function (value) {
                return value.cruise === cruise.cruiseID;
            }) != undefined) {
                return true;
            }
            return false;
        });
        route.cruises = lodash_1.map(route.cruises, function (cruise) {
            cruise.priceInfo = lodash_1.find(cruise.prices[store.state.config.persons], {
                priceModel: 'VARIO',
            });
            if (!cruise.priceInfo) {
                return;
            }
            cruise.priceModel = cruise.priceInfo.priceModel;
            cruise.price = cruise.priceInfo.amount;
            var priceData = lodash_1.find(cruise.prices[store.state.config.persons], function (price) {
                return price.priceModel === cruise.priceInfo.priceModel;
            });
            cruise.flight = priceData && priceData.flight ? priceData.flight : false;
            return cruise;
        });
        route.cruises = lodash_1.compact(route.cruises);
        if (route.cruises.length) {
            var cruise = lodash_1.minBy(route.cruises, 'price');
            route.cheapestCruiseIndex = lodash_1.findIndex(route.cruises, {
                price: cruise.price,
            });
        }
        return route;
    });
    routes = lodash_1.filter(routes, function (route) {
        return route.cruises.length;
    });
    lodash_1.map(routes, function (route) {
        route.cruises = lodash_1.map(route.cruises, function (cruise) {
            cruise.datesDisplay = cruise.start + " bis " + cruise.end;
            return cruise;
        });
        route.cruises = lodash_1.sortBy(route.cruises, function (cruise) {
            return moment_1.utc(cruise.start, 'DD.MM.YYYY').unix();
        });
        if (route.startHabour === route.endHabour) {
            route.description = route.duration + " Tage ab/bis " + route.startHabour;
        }
        else {
            route.description = route.duration + " Tage von " + route.startHabour + " nach " + route.endHabour;
        }
    });
    return routes;
}
//# sourceMappingURL=actions.js.map